<template>
  <div class="container">
    <h2 class="">
      <i18n path="common.install"></i18n>
    </h2>

    <p>
      <i18n path="common.guide.useNpm"></i18n>
    </p>
    <showcode :trigger="false">
      <pre>npm i -S v-uploader</pre>
    </showcode>
    <p>
      <i18n path="common.guide.include"></i18n>
    </p>
    <showcode :trigger="false">
      <v-code lang="javascript">
        <pre>
        import Vue from 'vue'
        import vUploader from 'v-uploader';

        // v-uploader plugin global config
        const uploaderConfig = {
          // file uploader service url
          uploadFileUrl: 'http://xxx/upload/publicFileUpload',
          // file delete service url
          deleteFileUrl: 'http://xxx/upload/deleteUploadFile',
          // set the way to show upload message(upload fail message)
          showMessage: (vue, message) => {
            //using v-dialogs to show message
            vue.$dlg.alert(message, {messageType: 'error'});
          }
        };

        // install plugin with options
        Vue.use(vUploader, uploaderConfig);
        </pre>
      </v-code>
    </showcode>
    <p>
      <i18n path="upload.useDialog"></i18n>
    </p>

    <div class="card p-4 font-monospace">
      <p>
        <i18n path="common.globalConfig"></i18n>
      </p>
      <ul>
        <li>language</li>
        <li>preview</li>
        <li>buttonText</li>
        <li>buttonIcon</li>
        <li>previewWidth</li>
        <li>previewHeight</li>
        <li>multiple</li>
        <li>uploadFileObjName</li>
        <li>itemLimit</li>
        <li>fileSizeLimit</li>
        <li>fileTypeExts</li>
        <li>imageMaxHeight</li>
        <li>imageMaxWidth</li>
        <li>imageMinHeight</li>
        <li>imageMinWidth</li>
        <li>
          uploadFileUrl (<i18n path="common.tbTitle.required"></i18n>)
        </li>
        <li>
          deleteFileUrl (<i18n path="common.tbTitle.required"></i18n>)
        </li>
        <li>
          showMessage (<i18n path="common.tbTitle.required"></i18n>)
        </li>
      </ul>
    </div>

    <h2 class="mt-5">
      <i18n path="common.deploy"></i18n>
    </h2>

    <showcode :trigger="false">
      <v-code>
        <pre>
        &lt;template&gt;
          &lt;!-- bind event 'done' to receive file uploaded info --&gt;
          &lt;v-uploader @done="uploadDone" &gt;&lt;/v-uploader&gt;
        &lt;/template&gt;

        &lt;script&gt;
          export default {
            methods:{
              // receive uploaded files info
              // @type Array
              uploadDone(files){
                if(files && Array.isArray(files) && files.length){
                  // do something...
                }
              }
            }
          }
        &lt;/script&gt;
        </pre>
      </v-code>
    </showcode>

    <h2 class="mt-5">
      <i18n path="common.example"></i18n>
      <small class="ms-2 text-muted">
        <i18n path="upload.demo.title"></i18n>
      </small>
    </h2>


    <h4 class="mt-4">
      <i18n path="upload.demo.single"></i18n>
    </h4>
    <div class="card shadow-sm p-5">
      <v-uploader @done="uploadDone"></v-uploader>
      <showcode>
        <v-code>
          <pre>
          &lt;v-uploader @done="uploadDone"&gt;&lt;/v-uploader&gt;

          &lt;script&gt;
          export default {
            methods: {
              uploadDone(files){
                if(files &amp;&amp; Array.isArray(files) &amp;&amp; files.length){
                  console.log(files);
                }
              }
            }
          }
          &lt;/script&gt;
          </pre>
        </v-code>
      </showcode>

      <h4 class="mt-5">
        <i18n path="upload.demo.customSize"></i18n>
      </h4>
      <v-uploader :preview-width="400" :preview-height="300"></v-uploader>
      <showcode>
        <v-code>
          <pre>
          &lt;v-uploader :preview-width="400" :preview-height="300" &gt;
          &lt;/v-uploader&gt;
          </pre>
        </v-code>
      </showcode>

      <h4 class="mt-5">
        <i18n path="upload.demo.noPreview"></i18n>
      </h4>
      <v-uploader :preview="false" @done="noPreUploaded"></v-uploader>

      <h4 class="mt-5">
        <i18n path="upload.demo.uploadedInfo"></i18n>
      </h4>
      <pre class="p-2 bg-light">{{JSON.stringify(uploaded, null, 4)}}</pre>
      <showcode>
        <v-code>
          <pre>
          &lt;v-uploader :preview="false" &gt;&lt;/v-uploader&gt;
          </pre>
        </v-code>
      </showcode>

      <h4 class="mt-5">
        <i18n path="upload.demo.buttonText"></i18n>
      </h4>
      <v-uploader button-text="Select file to upload"></v-uploader>
      <showcode>
        <v-code>
          <pre>
          &lt;v-uploader button-text="Select file to upload" &gt;&lt;/v-uploader&gt;
          </pre>
        </v-code>
      </showcode>

      <h4 class="mt-5">
        <i18n path="upload.demo.noIcon"></i18n>
      </h4>
      <v-uploader :button-icon="false"></v-uploader>
      <showcode>
        <v-code>
          <pre>
          &lt;v-uploader :button-icon="false" &gt;&lt;/v-uploader&gt;
          </pre>
        </v-code>
      </showcode>

      <h4 class="mt-5">
        <i18n path="upload.demo.customPreviewImage"></i18n>
      </h4>
      <v-uploader :preview-img="require('../../assets/logo.png')"></v-uploader>
      <showcode>
        <v-code>
          <pre>
          &lt;v-uploader preview-img="http://xxx.com/a.jpg" &gt;
          &lt;/v-uploader&gt;
          </pre>
        </v-code>
      </showcode>
    </div>

    <h4 class="mt-5">
      <i18n path="upload.demo.multiple"></i18n>
      <small class="ms-3 text-muted">
        <i18n path="upload.demo.multipleSub"></i18n>
      </small>
    </h4>
    <div class="card shadow-sm p-5">
      <v-uploader :multiple="true" @done="uploadDone"></v-uploader>
      <showcode>
        <v-code>
          <pre>
          &lt;v-uploader :multiple="true"&gt;&lt;/v-uploader&gt;
          </pre>
        </v-code>
      </showcode>
    </div>

    <h2 class="mt-5">
      <i18n path="common.options"></i18n>
    </h2>
    <table class="table table-bordered table-striped font-monospace">
      <thead>
        <tr>
          <th>
            <i18n path="common.tbTitle.name"></i18n>
          </th>
          <th>
            <i18n path="common.tbTitle.type"></i18n>
          </th>
          <th>
            <i18n path="common.tbTitle.desc"></i18n>
          </th>
          <th>
            <i18n path="common.tbTitle.required"></i18n>
          </th>
          <th>
            <i18n path="common.tbTitle.default"></i18n>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>upload-file-url</td>
          <td>string</td>
          <td>
            <i18n path="upload.option.uploadFileUrl"></i18n>
          </td>
          <td>true</td>
          <td></td>
        </tr>
        <tr>
          <td>delete-file-url</td>
          <td>string</td>
          <td>
            <i18n path="upload.option.deleteFileUrl"></i18n>
          </td>
          <td>true</td>
          <td></td>
        </tr>
        <tr>
          <td>show-message</td>
          <td>function</td>
          <td>
            <i18n path="upload.option.showMessage"></i18n>
          </td>
          <td>true</td>
          <td></td>
        </tr>
        <tr>
          <td>multiple</td>
          <td>boolean</td>
          <td>
            <i18n path="upload.option.multiple"></i18n>
          </td>
          <td>false</td>
          <td>false</td>
        </tr>
        <tr>
          <td>language</td>
          <td>string</td>
          <td>
            <i18n path="upload.option.language"></i18n>
            <ul>
              <li>
                <code>'cn'</code>
              </li>
              <li>
                <code>'en'</code>
              </li>
            </ul>
          </td>
          <td>false</td>
          <td>'cn'</td>
        </tr>
        <tr>
          <td>preview</td>
          <td>boolean</td>
          <td>
            <i18n path="upload.option.preview"></i18n>
          </td>
          <td>false</td>
          <td>true</td>
        </tr>
        <tr>
          <td>preview-img</td>
          <td>string</td>
          <td>
            <i18n path="upload.option.previewImg"></i18n>
          </td>
          <td>false</td>
          <td></td>
        </tr>
        <tr>
          <td>preview-width</td>
          <td>number</td>
          <td>
            <i18n path="upload.option.previewWidth"></i18n>
          </td>
          <td>false</td>
          <td>200</td>
        </tr>
        <tr>
          <td>preview-height</td>
          <td>number</td>
          <td>
            <i18n path="upload.option.previewHeight"></i18n>
          </td>
          <td>false</td>
          <td>150</td>
        </tr>
        <tr>
          <td>file-size-limit</td>
          <td>string</td>
          <td>
            <i18n path="upload.option.fileSizeLimit"></i18n>
          </td>
          <td>false</td>
          <td>'5MB'</td>
        </tr>
        <tr>
          <td>file-type-exts</td>
          <td>string</td>
          <td>
            <i18n path="upload.option.fileTypeExts"></i18n>
          </td>
          <td>false</td>
          <td>'jpeg,jpg,gif,png'</td>
        </tr>
        <tr>
          <td>image-max-height</td>
          <td>number</td>
          <td>
            <i18n path="upload.option.imageMaxHeight"></i18n>
          </td>
          <td>false</td>
          <td>0</td>
        </tr>
        <tr>
          <td>image-max-width</td>
          <td>number</td>
          <td>
            <i18n path="upload.option.imageMaxWidth"></i18n>
          </td>
          <td>false</td>
          <td>0</td>
        </tr>
        <tr>
          <td>image-min-height</td>
          <td>number</td>
          <td>
            <i18n path="upload.option.imageMinHeight"></i18n>
          </td>
          <td>false</td>
          <td>0</td>
        </tr>
        <tr>
          <td>image-min-width</td>
          <td>number</td>
          <td>
            <i18n path="upload.option.imageMinWidth"></i18n>
          </td>
          <td>false</td>
          <td>0</td>
        </tr>
        <tr>
          <td>button-text</td>
          <td>string</td>
          <td>
            <i18n path="upload.option.buttonText"></i18n>
          </td>
          <td>false</td>
          <td></td>
        </tr>
        <tr>
          <td>button-icon</td>
          <td>boolean</td>
          <td>
            <i18n path="upload.option.buttonIcon"></i18n>
          </td>
          <td>false</td>
          <td>true</td>
        </tr>
        <tr>
          <td>upload-file-obj-name</td>
          <td>string</td>
          <td>
            <i18n path="upload.option.uploadFileObjName"></i18n>
          </td>
          <td>false</td>
          <td>'uploadFileObj'</td>
        </tr>
        <tr>
          <td>item-limit</td>
          <td>number</td>
          <td>
            <i18n path="upload.option.itemLimit"></i18n>
          </td>
          <td>false</td>
          <td>0</td>
        </tr>
        <tr>
          <td>before-upload</td>
          <td>function</td>
          <td>
            <i18n path="upload.option.beforeUpload"></i18n>
          </td>
          <td>false</td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <br />
    <br />

    <h2 class="mt-5">
      <i18n path="common.events"></i18n>
    </h2>
    <table class="table table-bordered table-striped font-monospace">
      <thead>
        <tr>
          <th>
            <i18n path="common.tbTitle.param"></i18n>
          </th>
          <th>
            <i18n path="common.tbTitle.desc"></i18n>
          </th>
          <th>
            <i18n path="common.tbTitle.args"></i18n>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>done</td>
          <td>
            <i18n path="upload.event.done"></i18n>
          </td>
          <td>
            <p>
              <i18n path="upload.event.doneArgs"></i18n>
            </p>
            <p>type: Array</p>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <br />

    <h2 class="mt-5">
      <i18n path="upload.server.title"></i18n>
    </h2>

    <h4>
      <i18n path="upload.server.request.title"></i18n>
    </h4>

    <table class="table table-bordered table-striped font-monospace">
      <thead>
        <tr>
          <th>
            <i18n path="common.tbTitle.param"></i18n>
          </th>
          <th>
            <i18n path="common.tbTitle.desc"></i18n>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>uploadFileObj</td>
          <td>
            <i18n path="upload.server.request.uploadFileObj"></i18n>
          </td>
        </tr>
        <tr>
          <td>fileSizeLimit</td>
          <td>
            <i18n path="upload.server.request.fileSizeLimit"></i18n>
          </td>
        </tr>
        <tr>
          <td>fileTypeExts</td>
          <td>
            <i18n path="upload.server.request.fileTypeExts"></i18n>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <br />

    <h4>
      <i18n path="upload.server.response.title"></i18n>
    </h4>
    <p>
      <i18n path="upload.server.response.desc"></i18n>
    </p>
    <table class="table table-bordered table-striped font-monospace">
      <thead>
        <tr>
          <th>
            <i18n path="common.tbTitle.prop"></i18n>
          </th>
          <th>
            <i18n path="common.tbTitle.type"></i18n>
          </th>
          <th>
            <i18n path="common.tbTitle.desc"></i18n>
          </th>
          <th>
            <i18n path="common.tbTitle.required"></i18n>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>success</td>
          <td>boolean</td>
          <td>
            <i18n path="upload.server.response.success"></i18n>
          </td>
          <td>true</td>
        </tr>
        <tr>
          <td>error</td>
          <td>string</td>
          <td>
            <i18n path="upload.server.response.error"></i18n>
          </td>
          <td>true</td>
        </tr>
        <tr>
          <td>url</td>
          <td>string</td>
          <td>
            <i18n path="upload.server.response.url"></i18n>
          </td>
          <td>true</td>
        </tr>
      </tbody>
    </table>
    <h5>
      <i18n path="upload.server.response.example"></i18n>
    </h5>
    <showcode :trigger="false">
      <v-code lang="javascript">
        <pre>
        {
          "success": true, // required field
          "error": null,   // when file upload fail, this field will set the fail reason
          "url": "https://xx/someimg.jpg" // a full path of image to show in thumbnail
        }
        </pre>
      </v-code>
    </showcode>
  </div>
</template>

<script>
export default {
  data () {
    return {
      customPreview: {
        language: 'en',
        previewImg: require('../../assets/logo.png')
      },
      singleCode: false,
      multipleCode: false,
      uploaded: {}
    }
  },
  methods: {
    uploadDone (files) {
      if (files && Array.isArray(files) && files.length) {
        console.log(files)
      }
    },
    noPreUploaded (files) {
      if (files && Array.isArray(files) && files.length) {
        this.uploaded = files[0]
      }
    }
  }
}
</script>
